module.exports = __webpack_public_path__ + "static/media/level4-off.52583a00.svg";